import { createSlice } from '@reduxjs/toolkit';

import { getSchoolById, updateSchoolById } from './actions';

const schoolSlice = createSlice({
  name: 'currentSchool',
  initialState: null,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getSchoolById.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(updateSchoolById.fulfilled, (state: any, action: any) => {
      return { ...state, ...action.payload };
    });
  },
});

export default schoolSlice.reducer;
